import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 11.746h-4.2l.4-3.91H17c.6 0 1-.391 1-.978 0-.586-.4-.977-1-.977h-3.5l.5-4.79c.1-.49-.3-.978-.9-1.076-.5-.097-1 .294-1.1.88l-.6 4.986h-4L8 1.09C8.1.6 7.7.113 7.1.015c-.5-.097-1 .294-1.1.88L5.4 5.88H1c-.6 0-1 .39-1 .977s.4.978 1 .978h4.2l-.4 3.91H1c-.6 0-1 .39-1 .978 0 .586.4.978 1 .978h3.5L4 18.49c-.1.488.3.977.9 1.075H5c.5 0 .9-.391 1-.88l.6-4.985h4l-.6 4.79c-.1.488.3.977.9 1.075h.1c.5 0 .9-.391 1-.88l.6-4.985H17c.6 0 1-.392 1-.978 0-.587-.4-.978-1-.978m-10.2 0 .4-3.91h4l-.4 3.91z"
    }, null, -1)
  ]))]))
}
export default { render: render }